import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Comment from '../../entities/comment';
export function deleteComment(comment: Comment, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = comment.id;}
const _work = workingSet();




comment.status = 'D';
comment.addedOn = newHRTimestamp();
comment.addedBy = getCurrentUserId();
comment.importSource = targetImportSource;
comment.importId = mergeId;
store.dispatch(Actions.CommentActions.removeCommentQueue(comment));
}


